/**
 * NOTE: THIS IS AN AUTO-GENERATED FILE. DO NOT MODIFY DIRECTLY.
 */
import * as z from 'zod'
import { AdsState, AdsStateFieldInputV2, AdsStateFieldV2, AdsStateValueInputV2, AdsStateValueV2, ArchiveMissionInput, AssignMissionInput, Camera, CameraImage, CameraInput, CancelMissionInput, Command, CommandResponse, ConnectivityState, ConnectivityStatus, ConnectivityStatusFieldInputV2, ConnectivityStatusFieldV2, ConnectivityStatusInput, ConnectivityStatusValueInputV2, ConnectivityStatusValueV2, ContinueStreamInput, ContinueVideoStream, Coordinate, CoordinateInput, CreateFleetInput, CreateHubInput, CreateMissionInputV2, CreateTeamInput, CreateUserInput, DeleteUserSuccessful, DeleteVehicleDeviationsInput, Deviation, DeviationCause, DeviationCauseInput, DeviationInput, DeviationState, DeviationValueInputV2, DeviationsFieldInputV2, DeviationsFieldV2, DeviationsValueV2, DriverMode, DriverModeFieldInputV2, DriverModeFieldV2, DriverModeValueInputV2, DriverModeValueV2, DrivingState, DrivingStateFieldInputV2, DrivingStateFieldV2, DrivingStateValueInputV2, DrivingStateValueV2, Error, ErrorInputV2, ErrorResponse, ErrorTypeV2, ErrorV2, GeneratedRoute, GeneratedRouteInputV2, GeneratedRouteV2, HealthStatus, HealthStatusInformation, Hub, HubInput, MRMState, MRMStateInput, MRMStateValue, Mission, MissionDataInputV3, MissionEvent, MissionEventInput, MissionEventType, MissionPayloadInputV3, MissionProgressDetails, MissionProgressDetailsFieldInputV2, MissionProgressDetailsFieldV2, MissionProgressDetailsInput, MissionProgressDetailsValueInputV2, MissionProgressDetailsValueV2, MissionState, MissionStateFieldInputV2, MissionStateFieldV2, MissionStateInput, MissionStateValue, MissionStateValueInputV2, MissionStateValueV2, MissionUnassigned, MissionUnassignedInputV3, MissionUpdateV3, MissionV2, MrmExecutionPhase, MrmStateFieldInputV2, MrmStateFieldV2, MrmStateValueDataInputV2, MrmStateValueDataV2, MrmStateValueInputV2, MrmStateValueV2, MrmTriggerValue, MrmType, NotFoundError, Owner, OwnerInput, Position, PositionFieldInputV2, PositionFieldV2, PositionInput, PositionValueInputV2, PositionValueV2, Reason, ResetMissionInput, ResetPasswordSuccessful, RoleClaim, Route, SelfDeleteError, Severity, SpeedMsFieldInputV2, SpeedMsFieldV2, SpeedMsValueInputV2, SpeedMsValueV2, StartMissionInput, Status, StringFieldInputV2, StringFieldV2, StringValueInputV2, StringValueV2, SystemError, SystemFleet, SystemFleetDetail, SystemRole, SystemTeam, SystemTeamInfo, SystemVersion, SystemVersionItem, Team, TeamFleetInfo, TeamInfo, TeamUserInfo, UpdateHubInput, UpdateTeamInput, UpdatedFleetInput, UpdatedGeneratedRouteInput, UpdatedMissionInput, UpdatedMissionInputV2, UpdatedMissionInputV3, UpdatedUserInput, UpdatedVehicleByVinInput, UpdatedVehicleInput, UpdatedVehicleInputV2, UpdatedVideoStreamingErrorInput, User, UserNotActiveError, UserTeam, ValidationError, Vehicle, VehicleCommandInput, VehicleInfo, VehicleList, VehicleV2, VideoStream, VideoStreamingError, VideoStreamingErrorCode } from './API'

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const AdsStateSchema = z.enum(AdsState);

export const CommandSchema = z.enum(Command);

export const ConnectivityStateSchema = z.enum(ConnectivityState);

export const DeviationStateSchema = z.enum(DeviationState);

export const DriverModeSchema = z.enum(DriverMode);

export const DrivingStateSchema = z.enum(DrivingState);

export const ErrorSchema = z.enum(Error);

export const ErrorTypeV2Schema = z.enum(ErrorTypeV2);

export const HealthStatusSchema = z.enum(HealthStatus);

export const MRMStateValueSchema = z.enum(MRMStateValue);

export const MissionEventTypeSchema = z.enum(MissionEventType);

export const MissionStateValueSchema = z.enum(MissionStateValue);

export const MrmExecutionPhaseSchema = z.enum(MrmExecutionPhase);

export const MrmTriggerValueSchema = z.enum(MrmTriggerValue);

export const MrmTypeSchema = z.enum(MrmType);

export const ReasonSchema = z.enum(Reason);

export const SeveritySchema = z.enum(Severity);

export const StatusSchema = z.enum(Status);

export const VideoStreamingErrorCodeSchema = z.enum(VideoStreamingErrorCode);

export function AdsStateFieldInputV2Schema(): z.ZodObject<Properties<AdsStateFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => AdsStateValueInputV2Schema().nullish())
  })
}

export function AdsStateFieldV2Schema(): z.ZodObject<Properties<AdsStateFieldV2>> {
  return z.object({
    __typename: z.literal('AdsStateFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => AdsStateValueV2Schema().nullish())
  })
}

export function AdsStateValueInputV2Schema(): z.ZodObject<Properties<AdsStateValueInputV2>> {
  return z.object({
    state: AdsStateSchema,
    updatedAt: z.string().datetime()
  })
}

export function AdsStateValueV2Schema(): z.ZodObject<Properties<AdsStateValueV2>> {
  return z.object({
    __typename: z.literal('AdsStateValueV2').optional(),
    state: AdsStateSchema,
    updatedAt: z.string().datetime()
  })
}

export function ArchiveMissionInputSchema(): z.ZodObject<Properties<ArchiveMissionInput>> {
  return z.object({
    missionId: z.string().min(1)
  })
}

export function AssignMissionInputSchema(): z.ZodObject<Properties<AssignMissionInput>> {
  return z.object({
    predefinedRouteId: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function CameraSchema(): z.ZodObject<Properties<Camera>> {
  return z.object({
    __typename: z.literal('Camera').optional(),
    id: z.string().nullish(),
    name: z.string().min(1)
  })
}

export function CameraImageSchema(): z.ZodObject<Properties<CameraImage>> {
  return z.object({
    __typename: z.literal('CameraImage').optional(),
    timestamp: z.string().datetime(),
    value: z.string().min(1)
  })
}

export function CameraInputSchema(): z.ZodObject<Properties<CameraInput>> {
  return z.object({
    id: z.string().nullish(),
    name: z.string().min(1)
  })
}

export function CancelMissionInputSchema(): z.ZodObject<Properties<CancelMissionInput>> {
  return z.object({
    missionId: z.string().min(1)
  })
}

export function CommandResponseSchema(): z.ZodObject<Properties<CommandResponse>> {
  return z.object({
    __typename: z.literal('CommandResponse').optional(),
    command: CommandSchema,
    errorMessage: z.string().nullish(),
    invocationId: z.string().min(1),
    isSuccess: z.boolean(),
    receivedByVehicleAt: z.string().datetime(),
    sentToVehicleAt: z.string().datetime(),
    vin: z.string().min(1)
  })
}

export function ConnectivityStatusSchema(): z.ZodObject<Properties<ConnectivityStatus>> {
  return z.object({
    __typename: z.literal('ConnectivityStatus').optional(),
    description: z.string().nullish(),
    expectedDisconnect: z.boolean().nullish(),
    latency: z.number().nullish(),
    reason: ReasonSchema.nullish(),
    state: ConnectivityStateSchema.nullish()
  })
}

export function ConnectivityStatusFieldInputV2Schema(): z.ZodObject<Properties<ConnectivityStatusFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => ConnectivityStatusValueInputV2Schema().nullish())
  })
}

export function ConnectivityStatusFieldV2Schema(): z.ZodObject<Properties<ConnectivityStatusFieldV2>> {
  return z.object({
    __typename: z.literal('ConnectivityStatusFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => ConnectivityStatusValueV2Schema().nullish())
  })
}

export function ConnectivityStatusInputSchema(): z.ZodObject<Properties<ConnectivityStatusInput>> {
  return z.object({
    description: z.string().nullish(),
    expectedDisconnect: z.boolean().nullish(),
    latency: z.number().nullish(),
    reason: ReasonSchema.nullish(),
    state: ConnectivityStateSchema.nullish()
  })
}

export function ConnectivityStatusValueInputV2Schema(): z.ZodObject<Properties<ConnectivityStatusValueInputV2>> {
  return z.object({
    expectDisconnection: z.boolean(),
    latency: z.number().nullish(),
    state: ConnectivityStateSchema.nullish(),
    updatedAt: z.string().datetime()
  })
}

export function ConnectivityStatusValueV2Schema(): z.ZodObject<Properties<ConnectivityStatusValueV2>> {
  return z.object({
    __typename: z.literal('ConnectivityStatusValueV2').optional(),
    expectDisconnection: z.boolean(),
    latency: z.number().nullish(),
    state: ConnectivityStateSchema.nullish(),
    updatedAt: z.string().datetime()
  })
}

export function ContinueStreamInputSchema(): z.ZodObject<Properties<ContinueStreamInput>> {
  return z.object({
    cameraID: z.string().nullish(),
    vin: z.string().min(1)
  })
}

export function ContinueVideoStreamSchema(): z.ZodObject<Properties<ContinueVideoStream>> {
  return z.object({
    __typename: z.literal('ContinueVideoStream').optional(),
    cameraID: z.string().nullish(),
    vin: z.string().min(1)
  })
}

export function CoordinateSchema(): z.ZodObject<Properties<Coordinate>> {
  return z.object({
    __typename: z.literal('Coordinate').optional(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
  })
}

export function CoordinateInputSchema(): z.ZodObject<Properties<CoordinateInput>> {
  return z.object({
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
  })
}

export function CreateFleetInputSchema(): z.ZodObject<Properties<CreateFleetInput>> {
  return z.object({
    name: z.string().min(1),
    teams: z.array(z.string().nullable()),
    vehicles: z.array(z.string().nullable())
  })
}

export function CreateHubInputSchema(): z.ZodObject<Properties<CreateHubInput>> {
  return z.object({
    active: z.boolean(),
    address: z.string().min(1),
    name: z.string().min(1),
    position: z.lazy(() => CoordinateInputSchema())
  })
}

export function CreateMissionInputV2Schema(): z.ZodObject<Properties<CreateMissionInputV2>> {
  return z.object({
    predefinedRouteId: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function CreateTeamInputSchema(): z.ZodObject<Properties<CreateTeamInput>> {
  return z.object({
    fleets: z.array(z.string().min(1)).nullish(),
    name: z.string().min(1),
    users: z.array(z.string().min(1)).nullish()
  })
}

export function CreateUserInputSchema(): z.ZodObject<Properties<CreateUserInput>> {
  return z.object({
    city: z.string().nullish(),
    country: z.string().nullish(),
    email: z.string().min(1),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    phone: z.string().nullish(),
    roles: z.array(z.string().min(1)),
    teams: z.array(z.string().min(1)).nullish()
  })
}

export function DeleteUserResultSchema() {
  return z.union([DeleteUserSuccessfulSchema(), NotFoundErrorSchema(), SelfDeleteErrorSchema(), SystemErrorSchema(), ValidationErrorSchema()])
}

export function DeleteUserSuccessfulSchema(): z.ZodObject<Properties<DeleteUserSuccessful>> {
  return z.object({
    __typename: z.literal('DeleteUserSuccessful').optional(),
    statusCode: z.number()
  })
}

export function DeleteVehicleDeviationsInputSchema(): z.ZodObject<Properties<DeleteVehicleDeviationsInput>> {
  return z.object({
    vin: z.string().min(1)
  })
}

export function DeviationSchema(): z.ZodObject<Properties<Deviation>> {
  return z.object({
    __typename: z.literal('Deviation').optional(),
    category: z.string().min(1),
    description: z.string().min(1),
    id: z.string().min(1),
    isBlocking: z.boolean(),
    origin: z.string().min(1),
    relatedDeviations: z.array(z.string().nullable()),
    resolvedAt: z.string().datetime().nullish(),
    sentAt: z.string().datetime(),
    severity: SeveritySchema,
    state: DeviationStateSchema
  })
}

export function DeviationCauseSchema(): z.ZodObject<Properties<DeviationCause>> {
  return z.object({
    __typename: z.literal('DeviationCause').optional(),
    deviationId: z.string().min(1)
  })
}

export function DeviationCauseInputSchema(): z.ZodObject<Properties<DeviationCauseInput>> {
  return z.object({
    deviationId: z.string().min(1)
  })
}

export function DeviationInputSchema(): z.ZodObject<Properties<DeviationInput>> {
  return z.object({
    category: z.string().min(1),
    description: z.string().min(1),
    id: z.string().min(1),
    isBlocking: z.boolean(),
    origin: z.string().min(1),
    relatedDeviations: z.array(z.string().nullable()),
    resolvedAt: z.string().datetime().nullish(),
    sentAt: z.string().datetime(),
    severity: SeveritySchema,
    state: DeviationStateSchema
  })
}

export function DeviationValueInputV2Schema(): z.ZodObject<Properties<DeviationValueInputV2>> {
  return z.object({
    deviation: z.lazy(() => DeviationInputSchema()),
    updatedAt: z.string().datetime()
  })
}

export function DeviationsFieldInputV2Schema(): z.ZodObject<Properties<DeviationsFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DeviationValueInputV2Schema().nullish())
  })
}

export function DeviationsFieldV2Schema(): z.ZodObject<Properties<DeviationsFieldV2>> {
  return z.object({
    __typename: z.literal('DeviationsFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DeviationsValueV2Schema().nullish())
  })
}

export function DeviationsValueV2Schema(): z.ZodObject<Properties<DeviationsValueV2>> {
  return z.object({
    __typename: z.literal('DeviationsValueV2').optional(),
    deviation: z.lazy(() => DeviationSchema()),
    updatedAt: z.string().datetime()
  })
}

export function DriverModeFieldInputV2Schema(): z.ZodObject<Properties<DriverModeFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DriverModeValueInputV2Schema().nullish())
  })
}

export function DriverModeFieldV2Schema(): z.ZodObject<Properties<DriverModeFieldV2>> {
  return z.object({
    __typename: z.literal('DriverModeFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DriverModeValueV2Schema().nullish())
  })
}

export function DriverModeValueInputV2Schema(): z.ZodObject<Properties<DriverModeValueInputV2>> {
  return z.object({
    mode: DriverModeSchema,
    updatedAt: z.string().datetime()
  })
}

export function DriverModeValueV2Schema(): z.ZodObject<Properties<DriverModeValueV2>> {
  return z.object({
    __typename: z.literal('DriverModeValueV2').optional(),
    mode: DriverModeSchema,
    updatedAt: z.string().datetime()
  })
}

export function DrivingStateFieldInputV2Schema(): z.ZodObject<Properties<DrivingStateFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DrivingStateValueInputV2Schema().nullish())
  })
}

export function DrivingStateFieldV2Schema(): z.ZodObject<Properties<DrivingStateFieldV2>> {
  return z.object({
    __typename: z.literal('DrivingStateFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => DrivingStateValueV2Schema().nullish())
  })
}

export function DrivingStateValueInputV2Schema(): z.ZodObject<Properties<DrivingStateValueInputV2>> {
  return z.object({
    state: DrivingStateSchema,
    updatedAt: z.string().datetime()
  })
}

export function DrivingStateValueV2Schema(): z.ZodObject<Properties<DrivingStateValueV2>> {
  return z.object({
    __typename: z.literal('DrivingStateValueV2').optional(),
    state: DrivingStateSchema,
    updatedAt: z.string().datetime()
  })
}

export function ErrorInputV2Schema(): z.ZodObject<Properties<ErrorInputV2>> {
  return z.object({
    raisedAt: z.string().datetime(),
    type: ErrorTypeV2Schema
  })
}

export function ErrorResponseSchema(): z.ZodObject<Properties<ErrorResponse>> {
  return z.object({
    __typename: z.literal('ErrorResponse').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function ErrorV2Schema(): z.ZodObject<Properties<ErrorV2>> {
  return z.object({
    __typename: z.literal('ErrorV2').optional(),
    raisedAt: z.string().datetime(),
    type: ErrorTypeV2Schema
  })
}

export function GeneratedRouteSchema(): z.ZodObject<Properties<GeneratedRoute>> {
  return z.object({
    __typename: z.literal('GeneratedRoute').optional(),
    createdAt: z.string().datetime(),
    durationInSeconds: z.number(),
    externalRouteId: z.string().min(1),
    landingHub: z.lazy(() => HubSchema()),
    launchHub: z.lazy(() => HubSchema()),
    predefinedRouteId: z.string().min(1),
    totalDistanceInMeters: z.number(),
    updatedAt: z.string().datetime(),
    waypoints: z.array(z.lazy(() => PositionSchema()))
  })
}

export function GeneratedRouteInputV2Schema(): z.ZodObject<Properties<GeneratedRouteInputV2>> {
  return z.object({
    createdAt: z.string().datetime(),
    durationInSeconds: z.number(),
    externalRouteId: z.string().min(1),
    landingHub: z.lazy(() => HubInputSchema()),
    launchHub: z.lazy(() => HubInputSchema()),
    positions: z.array(z.lazy(() => PositionInputSchema())),
    predefinedRouteId: z.string().min(1),
    totalDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function GeneratedRouteOrErrorSchema() {
  return z.union([ErrorResponseSchema(), GeneratedRouteV2Schema()])
}

export function GeneratedRouteV2Schema(): z.ZodObject<Properties<GeneratedRouteV2>> {
  return z.object({
    __typename: z.literal('GeneratedRouteV2').optional(),
    createdAt: z.string().datetime(),
    durationInSeconds: z.number(),
    externalRouteId: z.string().min(1),
    landingHub: z.lazy(() => HubSchema()),
    launchHub: z.lazy(() => HubSchema()),
    positions: z.array(z.lazy(() => PositionSchema())),
    predefinedRouteId: z.string().min(1),
    totalDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function HealthStatusInformationSchema(): z.ZodObject<Properties<HealthStatusInformation>> {
  return z.object({
    __typename: z.literal('HealthStatusInformation').optional(),
    status: HealthStatusSchema
  })
}

export function HubSchema(): z.ZodObject<Properties<Hub>> {
  return z.object({
    __typename: z.literal('Hub').optional(),
    active: z.boolean(),
    address: z.string().nullish(),
    createdAt: z.string().datetime(),
    id: z.string().min(1),
    name: z.string().min(1),
    position: z.lazy(() => CoordinateSchema()),
    updatedAt: z.string().datetime()
  })
}

export function HubInputSchema(): z.ZodObject<Properties<HubInput>> {
  return z.object({
    active: z.boolean(),
    address: z.string().nullish(),
    createdAt: z.string().datetime(),
    id: z.string().min(1),
    name: z.string().min(1),
    position: z.lazy(() => CoordinateInputSchema()),
    updatedAt: z.string().datetime()
  })
}

export function MRMStateSchema(): z.ZodObject<Properties<MRMState>> {
  return z.object({
    __typename: z.literal('MRMState').optional(),
    causes: z.array(z.lazy(() => DeviationCauseSchema())).nullish(),
    error: ErrorSchema.nullish(),
    mrmExecutionPhase: MrmExecutionPhaseSchema.nullish(),
    mrmType: MrmTypeSchema.nullish(),
    startedAt: z.string().datetime().nullish(),
    triggerBy: MrmTriggerValueSchema.nullish(),
    updatedAt: z.string().datetime(),
    value: MRMStateValueSchema
  })
}

export function MRMStateInputSchema(): z.ZodObject<Properties<MRMStateInput>> {
  return z.object({
    causes: z.array(z.lazy(() => DeviationCauseInputSchema())).nullish(),
    error: ErrorSchema.nullish(),
    mrmExecutionPhase: MrmExecutionPhaseSchema.nullish(),
    mrmType: MrmTypeSchema.nullish(),
    startedAt: z.string().datetime().nullish(),
    triggerBy: MrmTriggerValueSchema.nullish(),
    updatedAt: z.string().datetime(),
    value: MRMStateValueSchema
  })
}

export function MissionSchema(): z.ZodObject<Properties<Mission>> {
  return z.object({
    __typename: z.literal('Mission').optional(),
    actualArrivalTime: z.string().datetime().nullish(),
    actualStartTime: z.string().datetime().nullish(),
    createdAt: z.string().datetime(),
    description: z.string().nullish(),
    events: z.array(z.lazy(() => MissionEventSchema())).nullish(),
    fleetId: z.string().nullish(),
    id: z.string().min(1),
    name: z.string().min(1),
    plannedArrivalTime: z.string().datetime().nullish(),
    progressDetails: z.lazy(() => MissionProgressDetailsSchema().nullish()),
    route: z.lazy(() => GeneratedRouteSchema().nullish()),
    state: z.lazy(() => MissionStateSchema()),
    updatedAt: z.string().datetime(),
    vin: z.string().min(1)
  })
}

export function MissionDataInputV3Schema(): z.ZodObject<Properties<MissionDataInputV3>> {
  return z.object({
    actualArrivalTime: z.string().datetime().nullish(),
    actualStartTime: z.string().datetime().nullish(),
    description: z.string().nullish(),
    events: z.array(z.lazy(() => MissionEventInputSchema().nullable())).nullish(),
    name: z.string().nullish(),
    plannedArrivalTime: z.string().datetime().nullish(),
    progressDetails: z.lazy(() => MissionProgressDetailsFieldInputV2Schema().nullish()),
    route: z.lazy(() => GeneratedRouteInputV2Schema().nullish()),
    state: z.lazy(() => MissionStateFieldInputV2Schema().nullish())
  })
}

export function MissionEventSchema(): z.ZodObject<Properties<MissionEvent>> {
  return z.object({
    __typename: z.literal('MissionEvent').optional(),
    createdAt: z.string().datetime(),
    lastRepeatedAt: z.string().datetime().nullish(),
    position: z.lazy(() => PositionSchema()),
    repeatCount: z.number().nullish(),
    type: MissionEventTypeSchema
  })
}

export function MissionEventInputSchema(): z.ZodObject<Properties<MissionEventInput>> {
  return z.object({
    createdAt: z.string().datetime(),
    lastRepeatedAt: z.string().datetime().nullish(),
    position: z.lazy(() => PositionInputSchema()),
    repeatCount: z.number().nullish(),
    type: MissionEventTypeSchema
  })
}

export function MissionOrErrorSchema() {
  return z.union([ErrorResponseSchema(), MissionV2Schema()])
}

export function MissionOrUnassignedSchema() {
  return z.union([MissionUnassignedSchema(), MissionV2Schema()])
}

export function MissionPayloadInputV3Schema(): z.ZodObject<Properties<MissionPayloadInputV3>> {
  return z.object({
    mission: z.lazy(() => MissionDataInputV3Schema().nullish()),
    unassigned: z.lazy(() => MissionUnassignedInputV3Schema().nullish())
  })
}

export function MissionProgressDetailsSchema(): z.ZodObject<Properties<MissionProgressDetails>> {
  return z.object({
    __typename: z.literal('MissionProgressDetails').optional(),
    eta: z.string().datetime(),
    remainingDistanceInMeters: z.number(),
    traveledDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function MissionProgressDetailsFieldInputV2Schema(): z.ZodObject<Properties<MissionProgressDetailsFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MissionProgressDetailsValueInputV2Schema().nullish())
  })
}

export function MissionProgressDetailsFieldV2Schema(): z.ZodObject<Properties<MissionProgressDetailsFieldV2>> {
  return z.object({
    __typename: z.literal('MissionProgressDetailsFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MissionProgressDetailsValueV2Schema().nullish())
  })
}

export function MissionProgressDetailsInputSchema(): z.ZodObject<Properties<MissionProgressDetailsInput>> {
  return z.object({
    eta: z.string().datetime(),
    remainingDistanceInMeters: z.number(),
    traveledDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function MissionProgressDetailsValueInputV2Schema(): z.ZodObject<Properties<MissionProgressDetailsValueInputV2>> {
  return z.object({
    eta: z.string().datetime(),
    remainingDistanceInMeters: z.number(),
    traveledDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function MissionProgressDetailsValueV2Schema(): z.ZodObject<Properties<MissionProgressDetailsValueV2>> {
  return z.object({
    __typename: z.literal('MissionProgressDetailsValueV2').optional(),
    eta: z.string().datetime(),
    remainingDistanceInMeters: z.number(),
    traveledDistanceInMeters: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function MissionStateSchema(): z.ZodObject<Properties<MissionState>> {
  return z.object({
    __typename: z.literal('MissionState').optional(),
    updatedAt: z.string().datetime(),
    value: MissionStateValueSchema
  })
}

export function MissionStateFieldInputV2Schema(): z.ZodObject<Properties<MissionStateFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MissionStateValueInputV2Schema().nullish())
  })
}

export function MissionStateFieldV2Schema(): z.ZodObject<Properties<MissionStateFieldV2>> {
  return z.object({
    __typename: z.literal('MissionStateFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MissionStateValueV2Schema().nullish())
  })
}

export function MissionStateInputSchema(): z.ZodObject<Properties<MissionStateInput>> {
  return z.object({
    updatedAt: z.string().datetime(),
    value: MissionStateValueSchema
  })
}

export function MissionStateValueInputV2Schema(): z.ZodObject<Properties<MissionStateValueInputV2>> {
  return z.object({
    state: MissionStateValueSchema,
    updatedAt: z.string().datetime()
  })
}

export function MissionStateValueV2Schema(): z.ZodObject<Properties<MissionStateValueV2>> {
  return z.object({
    __typename: z.literal('MissionStateValueV2').optional(),
    state: MissionStateValueSchema,
    updatedAt: z.string().datetime()
  })
}

export function MissionUnassignedSchema(): z.ZodObject<Properties<MissionUnassigned>> {
  return z.object({
    __typename: z.literal('MissionUnassigned').optional(),
    fleetId: z.string().min(1),
    timestamp: z.string().datetime(),
    version: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function MissionUnassignedInputV3Schema(): z.ZodObject<Properties<MissionUnassignedInputV3>> {
  return z.object({
    _placeholder: z.boolean().nullish()
  })
}

export function MissionUpdateV3Schema(): z.ZodObject<Properties<MissionUpdateV3>> {
  return z.object({
    __typename: z.literal('MissionUpdateV3').optional(),
    fleetId: z.string().nullish(),
    payload: z.lazy(() => MissionOrUnassignedSchema()),
    vin: z.string().min(1)
  })
}

export function MissionV2Schema(): z.ZodObject<Properties<MissionV2>> {
  return z.object({
    __typename: z.literal('MissionV2').optional(),
    actualArrivalTime: z.string().datetime().nullish(),
    actualStartTime: z.string().datetime().nullish(),
    description: z.string().nullish(),
    events: z.array(z.lazy(() => MissionEventSchema())).nullish(),
    fleetId: z.string().min(1),
    id: z.string().min(1),
    name: z.string().min(1),
    plannedArrivalTime: z.string().datetime().nullish(),
    progressDetails: z.lazy(() => MissionProgressDetailsFieldV2Schema().nullish()),
    route: z.lazy(() => GeneratedRouteV2Schema().nullish()),
    state: z.lazy(() => MissionStateFieldV2Schema().nullish()),
    timestamp: z.string().datetime(),
    version: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function MrmStateFieldInputV2Schema(): z.ZodObject<Properties<MrmStateFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MrmStateValueInputV2Schema().nullish())
  })
}

export function MrmStateFieldV2Schema(): z.ZodObject<Properties<MrmStateFieldV2>> {
  return z.object({
    __typename: z.literal('MrmStateFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => MrmStateValueV2Schema().nullish())
  })
}

export function MrmStateValueDataInputV2Schema(): z.ZodObject<Properties<MrmStateValueDataInputV2>> {
  return z.object({
    causes: z.array(z.string().nullable()).nullish(),
    executionPhase: MrmExecutionPhaseSchema.nullish(),
    mrmType: MrmTypeSchema.nullish(),
    startedAt: z.string().datetime().nullish(),
    triggerBy: MrmTriggerValueSchema.nullish(),
    value: MRMStateValueSchema
  })
}

export function MrmStateValueDataV2Schema(): z.ZodObject<Properties<MrmStateValueDataV2>> {
  return z.object({
    __typename: z.literal('MrmStateValueDataV2').optional(),
    causes: z.array(z.string().nullable()).nullish(),
    executionPhase: MrmExecutionPhaseSchema.nullish(),
    mrmType: MrmTypeSchema.nullish(),
    startedAt: z.string().datetime().nullish(),
    triggerBy: MrmTriggerValueSchema.nullish(),
    value: MRMStateValueSchema
  })
}

export function MrmStateValueInputV2Schema(): z.ZodObject<Properties<MrmStateValueInputV2>> {
  return z.object({
    data: z.lazy(() => MrmStateValueDataInputV2Schema()),
    updatedAt: z.string().datetime()
  })
}

export function MrmStateValueV2Schema(): z.ZodObject<Properties<MrmStateValueV2>> {
  return z.object({
    __typename: z.literal('MrmStateValueV2').optional(),
    data: z.lazy(() => MrmStateValueDataV2Schema()),
    updatedAt: z.string().datetime()
  })
}

export function NotFoundErrorSchema(): z.ZodObject<Properties<NotFoundError>> {
  return z.object({
    __typename: z.literal('NotFoundError').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function OwnerSchema(): z.ZodObject<Properties<Owner>> {
  return z.object({
    __typename: z.literal('Owner').optional(),
    email: z.string().min(1),
    fullName: z.string().min(1),
    id: z.string().min(1),
    phoneNumber: z.string().min(1),
    position: z.string().min(1)
  })
}

export function OwnerInputSchema(): z.ZodObject<Properties<OwnerInput>> {
  return z.object({
    email: z.string().min(1),
    fullName: z.string().min(1),
    id: z.string().min(1),
    phoneNumber: z.string().min(1),
    position: z.string().min(1)
  })
}

export function PositionSchema(): z.ZodObject<Properties<Position>> {
  return z.object({
    __typename: z.literal('Position').optional(),
    altitude: z.number().nullish(),
    heading: z.number().nullish(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
  })
}

export function PositionFieldInputV2Schema(): z.ZodObject<Properties<PositionFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => PositionValueInputV2Schema().nullish())
  })
}

export function PositionFieldV2Schema(): z.ZodObject<Properties<PositionFieldV2>> {
  return z.object({
    __typename: z.literal('PositionFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => PositionValueV2Schema().nullish())
  })
}

export function PositionInputSchema(): z.ZodObject<Properties<PositionInput>> {
  return z.object({
    altitude: z.number().nullish(),
    heading: z.number().nullish(),
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
  })
}

export function PositionValueInputV2Schema(): z.ZodObject<Properties<PositionValueInputV2>> {
  return z.object({
    position: z.lazy(() => PositionInputSchema()),
    updatedAt: z.string().datetime()
  })
}

export function PositionValueV2Schema(): z.ZodObject<Properties<PositionValueV2>> {
  return z.object({
    __typename: z.literal('PositionValueV2').optional(),
    position: z.lazy(() => PositionSchema()),
    updatedAt: z.string().datetime()
  })
}

export function ResetMissionInputSchema(): z.ZodObject<Properties<ResetMissionInput>> {
  return z.object({
    missionId: z.string().min(1)
  })
}

export function ResetPasswordResultSchema() {
  return z.union([NotFoundErrorSchema(), ResetPasswordSuccessfulSchema(), SystemErrorSchema(), UserNotActiveErrorSchema(), ValidationErrorSchema()])
}

export function ResetPasswordSuccessfulSchema(): z.ZodObject<Properties<ResetPasswordSuccessful>> {
  return z.object({
    __typename: z.literal('ResetPasswordSuccessful').optional(),
    statusCode: z.number()
  })
}

export function RoleClaimSchema(): z.ZodObject<Properties<RoleClaim>> {
  return z.object({
    __typename: z.literal('RoleClaim').optional(),
    createdAt: z.string().datetime(),
    pattern: z.string().min(1),
    updatedAt: z.string().datetime()
  })
}

export function RouteSchema(): z.ZodObject<Properties<Route>> {
  return z.object({
    __typename: z.literal('Route').optional(),
    averageDuration: z.number(),
    createdAt: z.string().datetime(),
    distance: z.number(),
    id: z.string().min(1),
    landingHub: z.lazy(() => HubSchema()),
    launchHub: z.lazy(() => HubSchema()),
    updatedAt: z.string().datetime()
  })
}

export function SelfDeleteErrorSchema(): z.ZodObject<Properties<SelfDeleteError>> {
  return z.object({
    __typename: z.literal('SelfDeleteError').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function SpeedMsFieldInputV2Schema(): z.ZodObject<Properties<SpeedMsFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => SpeedMsValueInputV2Schema().nullish())
  })
}

export function SpeedMsFieldV2Schema(): z.ZodObject<Properties<SpeedMsFieldV2>> {
  return z.object({
    __typename: z.literal('SpeedMsFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => SpeedMsValueV2Schema().nullish())
  })
}

export function SpeedMsValueInputV2Schema(): z.ZodObject<Properties<SpeedMsValueInputV2>> {
  return z.object({
    speedMs: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function SpeedMsValueV2Schema(): z.ZodObject<Properties<SpeedMsValueV2>> {
  return z.object({
    __typename: z.literal('SpeedMsValueV2').optional(),
    speedMs: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function StartMissionInputSchema(): z.ZodObject<Properties<StartMissionInput>> {
  return z.object({
    missionId: z.string().min(1)
  })
}

export function StringFieldInputV2Schema(): z.ZodObject<Properties<StringFieldInputV2>> {
  return z.object({
    error: z.lazy(() => ErrorInputV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => StringValueInputV2Schema().nullish())
  })
}

export function StringFieldV2Schema(): z.ZodObject<Properties<StringFieldV2>> {
  return z.object({
    __typename: z.literal('StringFieldV2').optional(),
    error: z.lazy(() => ErrorV2Schema().nullish()),
    ttl: z.number().nullish(),
    value: z.lazy(() => StringValueV2Schema().nullish())
  })
}

export function StringValueInputV2Schema(): z.ZodObject<Properties<StringValueInputV2>> {
  return z.object({
    data: z.string().min(1),
    updatedAt: z.string().datetime()
  })
}

export function StringValueV2Schema(): z.ZodObject<Properties<StringValueV2>> {
  return z.object({
    __typename: z.literal('StringValueV2').optional(),
    data: z.string().min(1),
    updatedAt: z.string().datetime()
  })
}

export function SystemErrorSchema(): z.ZodObject<Properties<SystemError>> {
  return z.object({
    __typename: z.literal('SystemError').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function SystemFleetSchema(): z.ZodObject<Properties<SystemFleet>> {
  return z.object({
    __typename: z.literal('SystemFleet').optional(),
    createdAt: z.string().datetime(),
    id: z.string().min(1),
    name: z.string().min(1),
    numberOfVehicles: z.number(),
    teams: z.array(z.lazy(() => TeamInfoSchema())).nullish(),
    updatedAt: z.string().datetime()
  })
}

export function SystemFleetDetailSchema(): z.ZodObject<Properties<SystemFleetDetail>> {
  return z.object({
    __typename: z.literal('SystemFleetDetail').optional(),
    fleetId: z.string().min(1),
    vehicles: z.array(z.lazy(() => VehicleInfoSchema().nullable())).nullish()
  })
}

export function SystemRoleSchema(): z.ZodObject<Properties<SystemRole>> {
  return z.object({
    __typename: z.literal('SystemRole').optional(),
    claims: z.array(z.lazy(() => RoleClaimSchema())),
    createdAt: z.string().datetime(),
    id: z.string().min(1),
    name: z.string().min(1),
    updatedAt: z.string().datetime(),
    useWildcardClaims: z.boolean()
  })
}

export function SystemTeamSchema(): z.ZodObject<Properties<SystemTeam>> {
  return z.object({
    __typename: z.literal('SystemTeam').optional(),
    createdAt: z.string().datetime(),
    id: z.string().min(1),
    name: z.string().min(1),
    numberOfFleets: z.number(),
    numberOfUsers: z.number(),
    updatedAt: z.string().datetime()
  })
}

export function SystemTeamInfoSchema(): z.ZodObject<Properties<SystemTeamInfo>> {
  return z.object({
    __typename: z.literal('SystemTeamInfo').optional(),
    createdAt: z.string().datetime(),
    fleets: z.array(z.lazy(() => TeamFleetInfoSchema())).nullish(),
    id: z.string().min(1),
    updatedAt: z.string().datetime(),
    users: z.array(z.lazy(() => TeamUserInfoSchema())).nullish()
  })
}

export function SystemVersionSchema(): z.ZodObject<Properties<SystemVersion>> {
  return z.object({
    __typename: z.literal('SystemVersion').optional(),
    services: z.array(z.lazy(() => SystemVersionItemSchema().nullable())).nullish(),
    version: z.string().min(1)
  })
}

export function SystemVersionItemSchema(): z.ZodObject<Properties<SystemVersionItem>> {
  return z.object({
    __typename: z.literal('SystemVersionItem').optional(),
    service: z.string().min(1),
    version: z.string().min(1)
  })
}

export function TeamSchema(): z.ZodObject<Properties<Team>> {
  return z.object({
    __typename: z.literal('Team').optional(),
    createdAt: z.string().datetime(),
    fleets: z.array(z.string().min(1)).nullish(),
    id: z.string().min(1),
    name: z.string().min(1),
    updatedAt: z.string().datetime(),
    users: z.array(z.string().min(1)).nullish()
  })
}

export function TeamFleetInfoSchema(): z.ZodObject<Properties<TeamFleetInfo>> {
  return z.object({
    __typename: z.literal('TeamFleetInfo').optional(),
    id: z.string().min(1),
    name: z.string().min(1)
  })
}

export function TeamInfoSchema(): z.ZodObject<Properties<TeamInfo>> {
  return z.object({
    __typename: z.literal('TeamInfo').optional(),
    id: z.string().min(1),
    name: z.string().min(1)
  })
}

export function TeamUserInfoSchema(): z.ZodObject<Properties<TeamUserInfo>> {
  return z.object({
    __typename: z.literal('TeamUserInfo').optional(),
    firstName: z.string().min(1),
    id: z.string().min(1),
    lastName: z.string().min(1)
  })
}

export function UpdateHubInputSchema(): z.ZodObject<Properties<UpdateHubInput>> {
  return z.object({
    active: z.boolean(),
    address: z.string().min(1),
    id: z.string().min(1),
    name: z.string().min(1),
    position: z.lazy(() => CoordinateInputSchema())
  })
}

export function UpdateTeamInputSchema(): z.ZodObject<Properties<UpdateTeamInput>> {
  return z.object({
    fleets: z.array(z.string().min(1)).nullish(),
    id: z.string().min(1),
    name: z.string().min(1),
    users: z.array(z.string().min(1)).nullish()
  })
}

export function UpdatedFleetInputSchema(): z.ZodObject<Properties<UpdatedFleetInput>> {
  return z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    teams: z.array(z.string().min(1)),
    vehicles: z.array(z.string().min(1))
  })
}

export function UpdatedGeneratedRouteInputSchema(): z.ZodObject<Properties<UpdatedGeneratedRouteInput>> {
  return z.object({
    createdAt: z.string().datetime(),
    durationInSeconds: z.number(),
    externalRouteId: z.string().min(1),
    landingHub: z.lazy(() => HubInputSchema()),
    launchHub: z.lazy(() => HubInputSchema()),
    predefinedRouteId: z.string().min(1),
    totalDistanceInMeters: z.number(),
    updatedAt: z.string().datetime(),
    waypoints: z.array(z.lazy(() => PositionInputSchema()))
  })
}

export function UpdatedMissionInputSchema(): z.ZodObject<Properties<UpdatedMissionInput>> {
  return z.object({
    actualArrivalTime: z.string().datetime().nullish(),
    actualStartTime: z.string().datetime().nullish(),
    createdAt: z.string().datetime(),
    description: z.string().nullish(),
    events: z.array(z.lazy(() => MissionEventInputSchema())).nullish(),
    fleetId: z.string().nullish(),
    id: z.string().min(1),
    name: z.string().min(1),
    plannedArrivalTime: z.string().datetime().nullish(),
    progressDetails: z.lazy(() => MissionProgressDetailsInputSchema().nullish()),
    route: z.lazy(() => UpdatedGeneratedRouteInputSchema().nullish()),
    state: z.lazy(() => MissionStateInputSchema()),
    updatedAt: z.string().datetime(),
    vin: z.string().min(1)
  })
}

export function UpdatedMissionInputV2Schema(): z.ZodObject<Properties<UpdatedMissionInputV2>> {
  return z.object({
    actualArrivalTime: z.string().datetime().nullish(),
    actualStartTime: z.string().datetime().nullish(),
    description: z.string().nullish(),
    events: z.array(z.lazy(() => MissionEventInputSchema().nullable())).nullish(),
    fleetId: z.string().nullish(),
    id: z.string().min(1),
    name: z.string().nullish(),
    plannedArrivalTime: z.string().datetime().nullish(),
    progressDetails: z.lazy(() => MissionProgressDetailsFieldInputV2Schema().nullish()),
    route: z.lazy(() => GeneratedRouteInputV2Schema().nullish()),
    state: z.lazy(() => MissionStateFieldInputV2Schema().nullish()),
    timestamp: z.string().datetime(),
    version: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function UpdatedMissionInputV3Schema(): z.ZodObject<Properties<UpdatedMissionInputV3>> {
  return z.object({
    fleetId: z.string().nullish(),
    missionId: z.string().nullish(),
    payload: z.lazy(() => MissionPayloadInputV3Schema()),
    timestamp: z.string().datetime(),
    version: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function UpdatedUserInputSchema(): z.ZodObject<Properties<UpdatedUserInput>> {
  return z.object({
    city: z.string().min(1),
    country: z.string().min(1),
    firstName: z.string().min(1),
    id: z.string().min(1),
    lastName: z.string().min(1),
    phone: z.string().min(1),
    roles: z.array(z.string().nullable()),
    teams: z.array(z.string().nullable())
  })
}

export function UpdatedVehicleByVinInputSchema(): z.ZodObject<Properties<UpdatedVehicleByVinInput>> {
  return z.object({
    activeMissionId: z.string().nullish(),
    adsState: AdsStateSchema,
    cameras: z.array(z.lazy(() => CameraInputSchema())),
    connectivityStatus: z.lazy(() => ConnectivityStatusInputSchema().nullish()),
    createdAt: z.string().datetime(),
    customerId: z.string().nullish(),
    deviations: z.array(z.lazy(() => DeviationInputSchema())),
    driverMode: DriverModeSchema.nullish(),
    drivingState: DrivingStateSchema,
    externalId: z.string().min(1),
    fleetId: z.string().nullish(),
    latestVehicleUpdate: z.string().datetime().nullish(),
    licensePlate: z.string().nullish(),
    mrmState: z.lazy(() => MRMStateInputSchema()),
    name: z.string().nullish(),
    owners: z.array(z.lazy(() => OwnerInputSchema())),
    position: z.lazy(() => PositionInputSchema().nullish()),
    speedInKmh: z.number().nullish(),
    speedInMs: z.number().nullish(),
    updatedAt: z.string().datetime(),
    vin: z.string().min(1),
    weightInKg: z.number().nullish()
  })
}

export function UpdatedVehicleInputSchema(): z.ZodObject<Properties<UpdatedVehicleInput>> {
  return z.object({
    activeMissionId: z.string().nullish(),
    adsState: AdsStateSchema,
    cameras: z.array(z.lazy(() => CameraInputSchema())),
    connectivityStatus: z.lazy(() => ConnectivityStatusInputSchema().nullish()),
    createdAt: z.string().datetime(),
    customerId: z.string().nullish(),
    deviations: z.array(z.lazy(() => DeviationInputSchema())),
    driverMode: DriverModeSchema.nullish(),
    drivingState: DrivingStateSchema,
    externalId: z.string().min(1),
    fleetId: z.string().nullish(),
    latestVehicleUpdate: z.string().datetime().nullish(),
    licensePlate: z.string().nullish(),
    mrmState: z.lazy(() => MRMStateInputSchema()),
    name: z.string().nullish(),
    owners: z.array(z.lazy(() => OwnerInputSchema())),
    position: z.lazy(() => PositionInputSchema().nullish()),
    speedInKmh: z.number().nullish(),
    speedInMs: z.number().nullish(),
    updatedAt: z.string().datetime(),
    vin: z.string().min(1),
    weightInKg: z.number().nullish()
  })
}

export function UpdatedVehicleInputV2Schema(): z.ZodObject<Properties<UpdatedVehicleInputV2>> {
  return z.object({
    activeMissionId: z.lazy(() => StringFieldInputV2Schema().nullish()),
    adsState: z.lazy(() => AdsStateFieldInputV2Schema().nullish()),
    connectivityStatus: z.lazy(() => ConnectivityStatusFieldInputV2Schema().nullish()),
    deviations: z.array(z.lazy(() => DeviationsFieldInputV2Schema().nullable())),
    driverMode: z.lazy(() => DriverModeFieldInputV2Schema().nullish()),
    drivingState: z.lazy(() => DrivingStateFieldInputV2Schema().nullish()),
    fleetId: z.string().nullish(),
    latestVehicleUpdate: z.string().datetime().nullish(),
    licensePlate: z.string().nullish(),
    mrmState: z.lazy(() => MrmStateFieldInputV2Schema().nullish()),
    name: z.string().nullish(),
    owners: z.array(z.lazy(() => OwnerInputSchema())),
    position: z.lazy(() => PositionFieldInputV2Schema().nullish()),
    speedMs: z.lazy(() => SpeedMsFieldInputV2Schema().nullish()),
    timestamp: z.string().datetime(),
    vin: z.string().min(1)
  })
}

export function UpdatedVideoStreamingErrorInputSchema(): z.ZodObject<Properties<UpdatedVideoStreamingErrorInput>> {
  return z.object({
    cameraID: z.string().nullish(),
    errorCode: VideoStreamingErrorCodeSchema,
    errorMessage: z.string().nullish(),
    vin: z.string().min(1)
  })
}

export function UserSchema(): z.ZodObject<Properties<User>> {
  return z.object({
    __typename: z.literal('User').optional(),
    city: z.string().nullish(),
    country: z.string().nullish(),
    createdAt: z.string().datetime(),
    email: z.string().min(1),
    firstName: z.string().min(1),
    id: z.string().min(1),
    lastName: z.string().min(1),
    phone: z.string().nullish(),
    roles: z.array(z.lazy(() => SystemRoleSchema())),
    status: StatusSchema,
    teams: z.array(z.lazy(() => UserTeamSchema())).nullish(),
    updatedAt: z.string().datetime()
  })
}

export function UserNotActiveErrorSchema(): z.ZodObject<Properties<UserNotActiveError>> {
  return z.object({
    __typename: z.literal('UserNotActiveError').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function UserTeamSchema(): z.ZodObject<Properties<UserTeam>> {
  return z.object({
    __typename: z.literal('UserTeam').optional(),
    id: z.string().min(1),
    name: z.string().min(1)
  })
}

export function ValidationErrorSchema(): z.ZodObject<Properties<ValidationError>> {
  return z.object({
    __typename: z.literal('ValidationError').optional(),
    errorCode: z.string().min(1),
    statusCode: z.number()
  })
}

export function VehicleSchema(): z.ZodObject<Properties<Vehicle>> {
  return z.object({
    __typename: z.literal('Vehicle').optional(),
    activeMissionId: z.string().nullish(),
    adsState: AdsStateSchema,
    cameras: z.array(z.lazy(() => CameraSchema())),
    connectivityStatus: z.lazy(() => ConnectivityStatusSchema().nullish()),
    createdAt: z.string().datetime(),
    customerId: z.string().nullish(),
    deviations: z.array(z.lazy(() => DeviationSchema())),
    driverMode: DriverModeSchema.nullish(),
    drivingState: DrivingStateSchema,
    externalId: z.string().min(1),
    fleetId: z.string().nullish(),
    latestVehicleUpdate: z.string().datetime().nullish(),
    licensePlate: z.string().nullish(),
    mrmState: z.lazy(() => MRMStateSchema()),
    name: z.string().nullish(),
    owners: z.array(z.lazy(() => OwnerSchema())),
    position: z.lazy(() => PositionSchema().nullish()),
    speedInKmh: z.number().nullish(),
    speedInMs: z.number().nullish(),
    updatedAt: z.string().datetime(),
    vin: z.string().min(1),
    weightInKg: z.number().nullish()
  })
}

export function VehicleCommandInputSchema(): z.ZodObject<Properties<VehicleCommandInput>> {
  return z.object({
    command: CommandSchema,
    vin: z.string().min(1)
  })
}

export function VehicleInfoSchema(): z.ZodObject<Properties<VehicleInfo>> {
  return z.object({
    __typename: z.literal('VehicleInfo').optional(),
    name: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function VehicleListSchema(): z.ZodObject<Properties<VehicleList>> {
  return z.object({
    __typename: z.literal('VehicleList').optional(),
    items: z.array(z.lazy(() => VehicleV2Schema().nullable())).nullish()
  })
}

export function VehicleListOrErrorSchema() {
  return z.union([ErrorResponseSchema(), VehicleListSchema()])
}

export function VehicleOrErrorSchema() {
  return z.union([ErrorResponseSchema(), VehicleV2Schema()])
}

export function VehicleV2Schema(): z.ZodObject<Properties<VehicleV2>> {
  return z.object({
    __typename: z.literal('VehicleV2').optional(),
    activeMissionId: z.lazy(() => StringFieldV2Schema().nullish()),
    adsState: z.lazy(() => AdsStateFieldV2Schema().nullish()),
    connectivityStatus: z.lazy(() => ConnectivityStatusFieldV2Schema().nullish()),
    deviations: z.array(z.lazy(() => DeviationsFieldV2Schema().nullable())).nullish(),
    driverMode: z.lazy(() => DriverModeFieldV2Schema().nullish()),
    drivingState: z.lazy(() => DrivingStateFieldV2Schema().nullish()),
    fleetId: z.string().nullish(),
    latestVehicleUpdate: z.string().datetime().nullish(),
    licensePlate: z.string().nullish(),
    mrmState: z.lazy(() => MrmStateFieldV2Schema().nullish()),
    name: z.string().min(1),
    owners: z.array(z.lazy(() => OwnerSchema())),
    position: z.lazy(() => PositionFieldV2Schema().nullish()),
    speedMs: z.lazy(() => SpeedMsFieldV2Schema().nullish()),
    timestamp: z.string().datetime(),
    vin: z.string().min(1)
  })
}

export function VideoStreamSchema(): z.ZodObject<Properties<VideoStream>> {
  return z.object({
    __typename: z.literal('VideoStream').optional(),
    cameraID: z.string().nullish(),
    streamingURL: z.string().min(1),
    vin: z.string().min(1)
  })
}

export function VideoStreamingErrorSchema(): z.ZodObject<Properties<VideoStreamingError>> {
  return z.object({
    __typename: z.literal('VideoStreamingError').optional(),
    cameraID: z.string().nullish(),
    errorCode: VideoStreamingErrorCodeSchema,
    errorMessage: z.string().nullish(),
    vin: z.string().min(1)
  })
}
